export default {
  state: {
    menuId: 0,
    showLeftMenu: true,
    source: ''
  },
  getters: {
    menuId: (state) => {
      return state.menuId
    }
  },
  mutations: {
    changeMenuId: (state, menuId) => {
      state.menuId = menuId
    },
    changeLeftMenuVisible: (state, v) => {
      state.showLeftMenu = v
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/menu.js